// Google Tag Manager snippet.
// Kept in a dedicated module and excluded from Prettier so the minified
// loader is never reformatted. See .prettierignore.
export const getGtmSnippet = (gtmTag) => `
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${gtmTag}');
`
